import React, {Fragment} from "react";
import {
  HashRouter,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import useStyles from './styles';
// components
import Layout from "./Layout";

// pages
import Error from "../pages/error";
import {Login, getLoginPath} from "../pages/newLogin";

import {CustomersContext} from "../context/CustomersContext";
import Rest from "../helpers/Rest";
import Pdu from "../pdu/Pdu";
import Occupancy from "../occupancy";
import SignedOut from "../pdu/screens/SignedOut"
import {DevicesContext} from "../context/DevicesContext";

function RequiringLogin(props) {
  const component = props.component
  return (
      <Route path={props.path} render={props => {
        if (!Rest.getUser()) {
          return <Redirect to="/login"/>
        }
        return React.createElement(component, props)
      }}/>
  )
}

export default function App() {
  const classes = useStyles();
  return (
    <>
    <ToastContainer
      className={classes.toastsContainer}
      position="top-right"
      closeOnClick={false}
    />
      <HashRouter>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/app/list-devices" />} />
          <Route
            exact
            path="/app"
            render={() => <Redirect to="/app/list-devices" />}
          />
          <Route path="/login" component={Login} />
          <Route path="/check-in/:qrCode" component={Pdu}/>
          <Route path="/signed-out" component={SignedOut}/>
          <RequiringLogin path="/occupancy" component={Occupancy}/>
          <DevicesContext>
            <CustomersContext>
              <RequiringLogin path="/app" component={Layout} />
            </CustomersContext>
          </DevicesContext>
          <Route component={Error} />
        </Switch>
      </HashRouter>
    </>
  );
}
